import { render, staticRenderFns } from "./KusClientAccessRolesDoc.vue?vue&type=template&id=2ab20d42"
import script from "./KusClientAccessRolesDoc.vue?vue&type=script&lang=js"
export * from "./KusClientAccessRolesDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports